import { useMemo, useState } from "react";

type IOptions = {
  checked: Array<boolean | undefined>;
  onChange: Array<
    undefined | ((event: React.ChangeEvent<HTMLInputElement>) => void)
  >;
};

export function useControllableRadioGroupState({
  checked,
  onChange,
}: IOptions) {
  const [uncontrolledValues, setUncontrolledValues] = useState(() =>
    Array<boolean>(checked.length).fill(false)
  );
  const _checked = useMemo(
    () => checked?.map((value, i) => value ?? uncontrolledValues[i] ?? false),
    [checked, uncontrolledValues]
  );
  const _onChange = useMemo(
    () =>
      onChange?.map(
        (callback, i) => (event: React.ChangeEvent<HTMLInputElement>) => {
          callback?.(event);
          setUncontrolledValues(() => {
            const values = Array<boolean>(onChange.length).fill(false);
            values.splice(i, 1, !!event.target.checked);
            return values;
          });
        }
      ),
    [onChange]
  );
  return [_checked, _onChange] as const;
}
